module.exports = __webpack_public_path__ + "static/media/1POLICY48.31d4f78a.jpg";